import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Col, Collapse, DatePicker, Form, Input, Modal, Row, Select, Space, Switch, Table } from "antd";
import { EyeOutlined } from '@ant-design/icons';

import { espacioBlanco, required } from "../../services/forms";
import http from "../../services/http";
import { modalError, modalSuccess } from "../../services/notifications";
import { actions, hasPermission, hasPermissionRestrict, hasRestrictContent } from "../../services/security";
import { BASEURL } from "../../services/url";
import "./Plantillas.scss"
import TextArea from "antd/lib/input/TextArea";
import ContentModal from "./Modal-content";
import { Context } from "../../store/masterDoc-context";

const PlantillasFormDetails = (props) => {
  let navigate = useNavigate();
  const [modal, setModal] = useState([])
  const { id } = props;
  const [form] = Form.useForm();

  const [modalVisible, setModalVisible] = useState(false)
  const [utilizable, setUtilizable] = useState(false);
  const [spiner, setSpiner] = useState(false)

  const [camposPlantilla, setCamposPlantilla] = useState([])
  const [tablasPlantilla, setTablasPlantilla] = useState([])
  const [tablasModal, setTablasModal] = useState([])
  const [state, setState] = useContext(Context);

  const disabled =
    (hasRestrictContent() !== true ? !hasPermission(actions.PlantillaMasterDocEditar)
      : !hasPermissionRestrict(actions.RestriccionEditar, state.codMaster))


  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function getForm() {
      setSpiner(true)

      let response = await http.get(`${BASEURL}/PlantillaMasterDoc/${id}`)
        .catch((error) => {
          if (error.response) {
            modalError(
              error.response.data.errores[0].titulo,
              error.response.data.errores[0].detalle,
            )
            setSpiner(false)
          }
        })

      if (response) {
        const data = response.data;
        data.fecha = data.fecha.split(" ")[0]

        setUtilizable(data.noUtilizable)
        setCamposPlantilla(data.variables.camposPlantilla)
        setTablasPlantilla(data.variables.tablasPlantilla)

        form.setFieldsValue(data);
      }
    }
    getForm();
  }, [id]);

  const onClickBack = () => {
    navigate("/plantillas");
  };

  const onClickSave = async (values) => {
    setLoading(true);

    let json = {
      descripcion: values.descripcion,
      noUtilizable: values.noUtilizable,
    }

    const response = await http.put(`${BASEURL}/PlantillaMasterDoc/${id}`, json)
      .catch((error) => {
        if (error.response) {
          modalError(
            error.response.data.errores[0].titulo,
            error.response.data.errores[0].detalle,
          )
        }
      })

    setLoading(false);

    if (response) {
      await modalSuccess(
        "Plantilla guardada",
        "La plantilla fue modificada exitosamente"
      );
      navigate("/plantillas");
    }
  };

  const columnasCampos = [
    {
      title: 'Nombre',
      dataIndex: 'nombre',
      key: 'nombre',
    },
    {
      title: 'Tipo de Dato',
      dataIndex: 'tipoDeCampo',
      key: 'tipoDeCampo',
      render: (text, record) => {
        let tipo = record
        if (tipo.tipoDeCampo) {
          return tipo.tipoDeCampo.nombre
        }
      }
    },
    {
      title: 'Accion',
      dataIndex: 'acciones',
      key: 'acciones',
      render: (text, record) => (
        <Space className="btn-container" size="middle">
          <Button
            className="btn-action"
            title="Ver Detalle"
            type="tertiary"
            shape="circle"
            size="large"
            icon={<EyeOutlined />}
            onClick={() => handleModal({ id: record.key, tipo: 0 })}>
          </Button>
        </Space>
      ),
    },
  ];

  const columnasTablas = [
    {
      title: 'Nombre',
      dataIndex: 'nombreTabla',
      key: 'nombreTabla',
    },
    {
      title: 'Accion',
      dataIndex: 'acciones',
      key: 'acciones',
      render: (text, record) => (
        <Space className="btn-container" size="middle">
          <Button
            className="btn-action"
            title="Ver Detalle"
            type="tertiary"
            shape="circle"
            size="large"
            icon={<EyeOutlined />}
            onClick={() => handleModal({ id: record.key, tipo: 1 })}>
          </Button>
        </Space>
      ),
    }
  ]

  const datosCamposPlantilla = camposPlantilla.map((campo, index) => ({
    key: index,
    nombre: campo.nombre,
    tipoDeCampo: campo.tipoDeCampo,
  }))

  const datosTablasPlantilla = tablasPlantilla.map((tabla, index) => ({
    key: index,
    nombreTabla: tabla.nombreTabla,
  }))

  const handleModal = (values) => {
    const { id, tipo } = values
    let tipoCampos = camposPlantilla
    let tipoTablas = tablasPlantilla

    const generateId = () => {
      return Math.random().toString(36).substr(2, 9);
    };

    if (tipo === 0) {
      tipoCampos = tipoCampos.filter((campo, index) => index === id ? campo : null).map((campo, index) => ({
        id: generateId(),
        nombre: campo.nombre,
        longitud: campo.longitud === 0 ? "Ilimitado" : campo.longitud,
        tipoDeCampo: campo.tipoDeCampo,
        tipoDeCampo: campo.tipoDeCampo,
        formatoDeEntrada: campo.formatoDeEntrada,
        caracterDeRelleno: campo.caracterDeRelleno,
        opciones: campo.opciones.length === 0 ? null : campo.opciones,
        descripcion: campo.descripcion,
        textoPorDefecto: campo.textoPorDefecto,
        tipo: tipo,
      }))
      setModal(tipoCampos)
      setModalVisible(true)
    }

    else if (tipo === 1) {
      tipoTablas = tipoTablas.filter((tabla, index) => index === id ? tabla : null).map((tabla, index) => ({
        id: generateId(),
        nombreTabla: tabla.nombreTabla,
        descripcion: tabla.descripcion,
        cantidadFilas: tabla.cantidadFilas,
        columnas: tabla.columnas,
        tipo: tipo,
        tablasDiccionario: tabla.tablaDiccionario ? { ...tabla.tablaDiccionario, id: generateId() } : null,
      }))
      setModal(tipoTablas)

      setTablasModal(tipoTablas)
      setModalVisible(true)
    }
  };

  const pagination = {
    defaultPageSize: 20,
    pageSizeOptions: ["20", "40", "60"],
    showSizeChanger: true,
    locale: { items_per_page: "" },
  };

  const handleCancel = () => {
    setModalVisible(false);
    setModal([]);
  };


  return (
    <Form layout="vertical" form={form} onFinish={onClickSave} >
      <Row gutter={16}>
        <Col xs={24}>
          <Form.Item label="Documento" name="nombreMasterDoc" rules={[required]}>
            <Input autoComplete='off' disabled={true} />
          </Form.Item>
        </Col>

        <Col xs={24}>
          <Form.Item label="Fecha" name="fecha" rules={[required]}>
            <Input autoComplete='off' disabled={true} />
          </Form.Item>
        </Col>

        <Col xs={24}>
          <Form.Item label="Versión" name="version" rules={[required]}>
            <Input autoComplete='off' disabled={true} />
          </Form.Item>
        </Col>

        <Col xs={24}>
          <Form.Item label="Descripción" name="descripcion" rules={[required]}>
            <TextArea rows={2} autoComplete='off' disabled={disabled} />
          </Form.Item>
        </Col>

        <Col xs={24}>
          <Form.Item label="Nombre archivo" name="nombreArchivo" rules={[required, espacioBlanco]}>
            <Input autoComplete='off' disabled={true} />
          </Form.Item>
        </Col>

        <Col xs={24}>
          <Form.Item label="No utilizable" name="noUtilizable" rules={[required]}>
            <Switch name="noUtilizable" onChange={() => utilizable ? setUtilizable(false) : setUtilizable(true)} checked={utilizable} rules={[required]} disabled={disabled} />
          </Form.Item>
        </Col>


        {
          camposPlantilla.length > 0 &&
          <Collapse className="collapse" defaultActiveKey={['1']}>
            <Collapse.Panel header="Campos" key="1">
              <Table
                className="table"
                columns={columnasCampos}
                key={camposPlantilla.map((item, index) => index)}
                dataSource={datosCamposPlantilla}
                pagination={pagination}
              />
            </Collapse.Panel>
          </Collapse>
        }

        {
          tablasPlantilla.length > 0 &&
          <Collapse className="collapse" defaultActiveKey={['1']}>
            <Collapse.Panel header="Tablas" key="1">
              <Table
                className="table"
                columns={columnasTablas}
                dataSource={datosTablasPlantilla}
                pagination={pagination}
                key={tablasPlantilla.map((item, index) => index)}
              />
            </Collapse.Panel>
          </Collapse>
        }

      </Row>
      <Modal
        className="modal"
        title="Detalle"
        open={modalVisible}
        onCancel={() => {

          handleCancel();
        }}
        footer={[
          <Button key="cerrar" onClick={() => {
            handleCancel()
          }}
          >
            Cerrar
          </Button>
        ]}
        width={1000}
      >
        {modal.map((item, index) => (
          <ContentModal
            key={index}
            tipo={item.tipo}
            item={item}
            tablas={tablasModal[0]}
          />
        ))}
      </Modal>


      <div className="actions">
        <Button type="text" onClick={onClickBack}>
          Volver
        </Button>
        {!disabled && (
          <Button type="primary" htmlType="submit" loading={loading}>
            {!loading && "Guardar"}
          </Button>
        )}
      </div>
    </Form >
  );
};

export default PlantillasFormDetails;
